import { css } from '@emotion/css';
import { SingleSelect, Html, Text, selectStyle } from 'Shared/forms/Inputs'
import { TextLayout } from 'Shared/model/Components';
import { contentOptions } from 'Shared/model/Fields';
import { For, Match, Switch } from 'solid-js';

const options = {
	teaser: 'Teaser',
	title: 'Title',
	tagline: 'Tagline',
	subtitle: 'Subtitle',
	plain: 'Description',
};

/*
	I'm currently making the assumption that text is or may be inline. It's not valid to 
	use <divs> inside  <h1>...<h6>, <p>, etc so for composite data I'm using <span>s.
*/

//XXX cf tying together HTML and CSS via styles where necessary


export function TextWidget(P:TextLayout)
{
//TODO entering plain text and then moving to one of the others leaves in the tags. Strip these. NOTE strip code in SectionTitle (+maybe elsewhere?)

	return (
		<Switch>
			<Match when={P.type=='plain'}>
				<Description {...P} />
			</Match>
			<Match when={true}>
				<MainText {...P} />
			</Match>
		</Switch>
	);
}	

function MainText(P)
{
	let textNode!:HTMLElement;

	const mainStyle = css({
		display: 'grid',
		gridTemplateColumns: 'auto 1fr',
		columnGap: '1em'
	});

	return (
		<div class={mainStyle}>
			<SingleSelect field='type' required={true} options={options}/>

			<Text ref={textNode} field='text'/>

			<div/>

			<div style={{'justify-self':'end','width':'unset'}}>
				<SelectDbField {...P} textNode={textNode} />
			</div>
		</div>
	);
}

function SelectDbField(P)
{
	const insertField = e => {
		P.textNode.value += '{'+e.target.value+'}';
		e.target.value = '';
	};

	return (
		<select class={css(selectStyle(true))} onChange={insertField}>
			<option value=''>– Insert field –</option>

			<For each={Object.entries(contentOptions)}>{([key,label]) => 
				<option value={key}>{label}</option>
			}</For>
		</select>
	);
}

function Description(P)
{
	let textNode!:HTMLElement;

	const descriptionStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '1em'
	});

	const descriptionTypeStyle = css({
		alignSelf: 'start',
	});


	return (
		<div class={descriptionStyle}>
			<SingleSelect field='type' class={descriptionTypeStyle} required={true} options={options}/>

			<Html field='text' ref={textNode} options={{
				height: 200,
				menubar: false,
				plugins: ['link'],
				toolbar: 'removeformat | undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | link | dbfields',
				statusbar: true,
				resize: true,  
				newline_behavior: 'linebreak',

				setup: editor => {
					editor.ui.registry.addMenuButton('dbfields', {
						text: 'Insert Field',
						fetch: cb => {
							let items = Object.entries(contentOptions).map(([key,label]) => ({
								type: 'menuitem',
								text: label,
								onAction: () => editor.insertContent('{' + key + '}')
							}));
							cb(items);
						}
					});
				}
			}} />
		</div>
	);
}

